import { useEffect, useState } from "react";
import { collection, getDocs, query, orderBy } from "firebase/firestore";

import Header from "../components/Header";
import ProfilePanel from "../components/ProfilePanel";
import BuzzListItem from "../components/BuzzListItem";

import { db } from "../auth/firebase";
import { LANGUAGES } from "../utils/languages";

function LatestBuzz() {
  const [buzz, setBuzz] = useState([]);
  const [language, setLanguage] = useState("all");
  const [searchQuery, setSearchQuery] = useState("");
  const [profileOpen, setProfileOpen] = useState(false);

  const clearFilters = () => {
    setLanguage("all");
    setSearchQuery("");
  };

  useEffect(() => {
    const loadBuzz = async () => {
      const q = query(
        collection(db, "latestBuzz"),
        orderBy("publishedAt", "desc")
      );

      const snapshot = await getDocs(q);
      const items = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      setBuzz(items);

      // Debug (optional)
      console.log("🔥 BUZZ COUNT:", items.length);
      console.log("🔥 LANGUAGES:", items.map((i) => i.language));
    };

    loadBuzz();
  }, []);

  /* ✅ CORRECT FILTER LOGIC */
  const filteredBuzz = buzz.filter((item) => {
    // Language filter
    if (language !== "all" && item.language !== language) {
      return false;
    }

    // Search filter
    if (
      searchQuery &&
      !item.title?.toLowerCase().includes(searchQuery.toLowerCase())
    ) {
      return false;
    }

    return true;
  });

  return (
    <>
      <Header
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
        onProfile={() => setProfileOpen(true)}
      />

      {/* LANGUAGE BAR */}
      <div className="language-bar">
        {LANGUAGES.map((l) => (
          <button
            key={l.value}
            type="button"
            className={`lang-btn ${language === l.value ? "active" : ""}`}
            onClick={() => setLanguage(l.value)}
          >
            {l.label}
          </button>
        ))}

        {(language !== "all" || searchQuery) && (
          <button
            type="button"
            className="clear-filters-btn"
            onClick={clearFilters}
          >
            Clear ✕
          </button>
        )}
      </div>

      <div className="container">


  <p style={{ opacity: 0.7, marginBottom: 8 }}>
    Official trailers, teasers & first looks
  </p>

  {/* RESULT COUNT */}
  <p
    style={{
      marginBottom: 16,
      fontSize: 14,
      opacity: 0.7,
    }}
  >
    {filteredBuzz.length > 0
      ? `Showing ${filteredBuzz.length} video${
          filteredBuzz.length > 1 ? "s" : ""
        }`
      : null}
  </p>

  {filteredBuzz.length === 0 ? (
    <p style={{ opacity: 0.6 }}>No latest Buzz updates</p>
  ) : <div className="buzz-grid">
  {filteredBuzz.map((item) => (
    <div key={item.id} className="buzz-card">
      <div className="thumb-wrapper">
        <img src={item.thumbnail} alt={item.title} />
        <span className="play-icon">▶</span>
      </div>

      <h3 className="buzz-title">{item.title}</h3>

      <p className="buzz-meta">
        {item.language} • {item.publishedAt}
      </p>
    </div>
  ))}
</div>
}
</div>


      <ProfilePanel open={profileOpen} onClose={() => setProfileOpen(false)} />
    </>
  );
}

export default LatestBuzz;
